<script lang="ts" setup>
import { ErrorMessage } from 'vee-validate'
import { toValue, reactive } from 'vue'
import { useFormField } from './useFormField'

const { name, formMessageId } = useFormField();

</script>

<template>
  <ErrorMessage :id="formMessageId" :name="toValue(name)" v-slot="{ message }">
    <div v-dompurify-html="message" class="text-body--xsmall font-medium text-[color:var(--input-error-border)]"></div>
  </ErrorMessage>
</template>

<style>
a.rich-validation-text {

  text-decoration: underline;
  
  &:hover {
    text-decoration: none;
  }
}
</style>